import { ToggleButtonGroup, ToggleButton, Typography } from '@mui/material'
import Constants from '../../../constants'

type ToggleOption = {
  value: string
  label: string
}

type SegmentedControlProps = {
  value: string
  onChange: (value: string) => void
  options: ToggleOption[]
  title?: string
}
// To use when binary choice is required (e.g. display)
const SegmentedControl: React.FC<SegmentedControlProps> = ({ value, onChange, options, title }) => {
  return (
    <>
    {title && <Typography fontSize={'12px'}>{title}</Typography>}
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      sx={{
        backgroundColor: Constants.colors.textFieldBackground,
        border: 'none',
        borderRadius: '8px',
        width: 'fit-content',
        p: '1px',
        '& .MuiToggleButton-root': { border: 'none', fontSize: '0.75rem', textTransform: 'none' },
        '& .MuiToggleButton-root.Mui-selected': {
          backgroundColor: 'white',
          borderRadius: '8px',
        },
      }}
      onChange={(_, newValue) => newValue && onChange(newValue)}>
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
    </>
  )
}

export default SegmentedControl
